export type ButtonPart = {
  default: string;
  hover: string;
  active: string;
  focus: string;
  disabled: string;
};

export const buttonStates = {
  blue: {
    text: 'text-white font-semibold [text-shadow:_0px_1px_2px_rgba(0,_0,_0,_0.30)] group-disabled/button:text-white/50',
    bg: {
      default: 'from-[#9769FC] to-[#7652ff]',
      hover:
        'group-hover/button:from-[#8F71FF] group-hover/button:to-[#8F70FC]',
      active:
        'group-active/button:from-[#6C4ACA] group-active/button:to-[#543AB5]',
      focus: '',
      disabled:
        'group-disabled/button:from-white/20 group-disabled/button:to-white/10',
    },
    border: {
      default: 'from-white/50 to-white/0',
      hover: 'group-hover/button:from-white/50 group-hover/button:to-white/0',
      active:
        'group-active/button:from-white/50 group-active/button:to-white/0',
      focus:
        'group-focus-visible/button:bg-white group-focus-visible/button:mix-blend-normal',
      disabled: '',
    },
  },
  primary: {
    text: 'text-white font-semibold [text-shadow:_0px_1px_2px_rgba(0,_0,_0,_0.30)] group-disabled/button:text-white/50',
    bg: {
      default: 'bg-gradient-to-r from-[#5865F2] to-[#7D15B1]',
      hover:
        'group-hover/button:from-[#8F71FF] group-hover/button:to-[#8F70FC]',
      active:
        'group-active/button:from-[#6C4ACA] group-active/button:to-[#543AB5]',
      focus: '',
      disabled:
        'group-disabled/button:from-white/20 group-disabled/button:to-white/10',
    },
    border: {
      default: 'from-white/30 to-white/10',
      hover: 'group-hover/button:from-white/30 group-hover/button:to-white/10',
      active:
        'group-active/button:from-white/30 group-active/button:to-white/10',
      focus:
        'group-focus-visible/button:bg-white group-focus-visible/button:mix-blend-normal',
      disabled: '',
    },
  },
  secondary: {
    text: 'text-bionic-greyDark font-medium group-disabled/button:text-white/50',
    bg: {
      default: 'from-[#FFFFFF] to-[#FFFFFF]',
      hover:
        'group-hover/button:from-[#D5D9DD] group-hover/button:to-[#D5D9DD]',
      active:
        'group-active/button:from-[#9EA6B0] group-active/button:to-[#9EA6B0]',
      focus:
        'group-focus-visible/button:from-[#C2C7CD] group-focus-visible/button:to-[#C2C7CD]',
      disabled:
        'group-disabled/button:from-white/20 group-disabled/button:to-white/10',
    },
    border: {
      default: 'from-white/50 to-white/0',
      hover: 'group-hover/button:from-white/50 group-hover/button:to-white/0',
      active:
        'group-active/button:from-white/50 group-active/button:to-white/0',
      focus:
        'group-focus-visible/button:bg-white group-focus-visible/button:mix-blend-normal',
      disabled: '',
    },
  },
  glass: {
    text: 'text-white font-semibold [text-shadow:_0px_1px_2px_rgba(0,_0,_0,_0.30)] group-disabled/button:text-white/50',
    bg: {
      default: 'bg-white/10',
      hover: 'group-hover/button:bg-white/20',
      active:
        'group-active/button:from-from-white/20 group-active/button:to-white/5 group-active/button:via-white/10',
      focus:
        'group-focus-visible/button:from-[#C2C7CD] group-focus-visible/button:to-[#C2C7CD]',
      disabled:
        'group-disabled/button:from-white/20 group-disabled/button:to-white/10',
    },
    border: {
      default: 'from-white/20 to-white/10',
      hover: 'group-hover/button:from-white/50 group-hover/button:to-white/0',
      active:
        'group-active/button:from-white/50 group-active/button:to-white/0',
      focus:
        'group-focus-visible/button:bg-white group-focus-visible/button:mix-blend-normal',
      disabled: '',
    },
  },
  destructive: {
    text: 'text-white font-semibold [text-shadow:_0px_1px_2px_rgba(0,_0,_0,_0.30)] group-disabled/button:text-white/50',
    bg: {
      default: 'from-[#B02928] to-[#912020]',
      hover:
        'group-hover/button:from-[#C93333] group-hover/button:to-[#B42828]',
      active:
        'group-active/button:from-[#912020] group-active/button:to-[#721919]',
      focus: '',
      disabled:
        'group-disabled/button:from-white/20 group-disabled/button:to-white/10',
    },
    border: {
      default: 'from-white/50 to-white/0',
      hover: 'group-hover/button:from-white/50 group-hover/button:to-white/0',
      active:
        'group-active/button:from-white/50 group-active/button:to-white/0',
      focus:
        'group-focus-visible/button:bg-white group-focus-visible/button:mix-blend-normal',
      disabled: '',
    },
  },
};
